package com.essntl.features.itinerary.ui.all_itinerary

import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryModel

sealed interface AllItineraryEvent {
    data object LoadAllItinerary : AllItineraryEvent

    data class FilterItinerary(val filterOptions: ItineraryFilterOptions) : AllItineraryEvent

    data class SelectItinerary(val itineraryId: String?) : AllItineraryEvent

    data class EditClient(
        val client: ClientModel,
        val itinerary: ItineraryModel,
    ) : AllItineraryEvent
}